import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

const propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.string.isRequired,
    color: PropTypes.string,
    overrideColor: PropTypes.object,
};

const BigIcon = ({classes, type, iconColor, icon}) => {
    const style = iconColor ? {
        backgroundColor: iconColor,
    } : {};

    return (
        <div className={`${classes.imgWrap}`} style={style}>
            <img className={classNames(classes.img, classes[type] ? classes[type] : '')} src={icon}/>
        </div>
    )
};

const styles = theme => ({
    imgWrap: {
        backgroundColor: props => theme.palette[props.color || 'green'],
        width: theme.channelItems.icon.width,
        height: theme.channelItems.icon.height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    img: {
        width: 'auto',
        maxWidth: '50px'
    },
    commands: {
        height: 25,
    },
    hashtags: {
        width: 23,
        height: 'auto'
    }
});

BigIcon.propTypes = propTypes;

export default injectSheet(styles)(BigIcon);



// WEBPACK FOOTER //
// ./src/app/components/BigIcon.js